import { dangerColor, primaryColor } from '@/styles/variants';
import { Alert } from '@arco-design/web-react';
import styled, { css } from 'styled-components';

interface AlertPrimaryProps {
  status?: 'default' | 'error';
}

/** 根据设计稿改的 Alert @see https://arco.design/react/components/alert */
export const AlertPrimary = styled(Alert)<AlertPrimaryProps>`
  background-color: #fff1f0;
  padding: 0 8px;
  border-radius: 4px;
  font-size: 14px;
  ${({ status }) => {
    switch (status) {
      case 'error':
        return css`
          border: 1px solid ${dangerColor};
          .arco-alert-icon-wrapper svg,
          .arco-alert-content {
            color: ${dangerColor};
          }
        `;
      case 'default':
      default:
        return css`
          border: 1px solid ${primaryColor};
          .arco-alert-icon-wrapper svg,
          .arco-alert-content {
            color: ${primaryColor};
          }
        `;
    }
  }}
`;
